module.exports = __webpack_public_path__ + "static/img/airfreight-left.cbd14140.jpg";